// extracted by mini-css-extract-plugin
export default {"noReviewsRow":"Reviews_noReviewsRow__OGyzK","noReviewsRow_icon":"Reviews_noReviewsRow_icon__3GmSo"};